(function($) {
    class MenuMobile {
        constructor(element) {
            this.element = element;
            this.menuIsActive = false;
            this.menu = element.querySelector('.c-menu-mobile__menu');
            this.toggler = element.querySelector('.c-menu-mobile__toggler');
            this.label = element.querySelector('.c-menu-mobile__label');
            this.focusableSelector = [
                'a[href]',
                'button:not([disabled])',
                'input:not([type="hidden"]):not([disabled])',
                'select:not([disabled])',
                'textarea:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(', ');

            this.handleKeydown = this.handleKeydown.bind(this);
            this.handleMenuClick = this.handleMenuClick.bind(this);

            this.setMenuFocusability(false);
            this.menu.setAttribute('aria-hidden', 'true');
    
            this.toggler.addEventListener('click', () => this.toggleMenu());
            this.menu.addEventListener('click', this.handleMenuClick);
            document.addEventListener('keydown', this.handleKeydown);
        }

        handleMenuClick(event) {
            const link = event.target.closest('a[href]');

            if (!this.menuIsActive || !link || !this.menu.contains(link)) {
                return;
            }

            if (
                event.defaultPrevented ||
                event.metaKey ||
                event.ctrlKey ||
                event.shiftKey ||
                event.altKey ||
                link.getAttribute('target') === '_blank'
            ) {
                return;
            }

            window.setTimeout(() => {
                this.toggleMenu(false);
            }, 600);
        }

        getMenuFocusableElements() {
            return Array.from(this.menu.querySelectorAll(this.focusableSelector))
                .filter((item) => !item.hasAttribute('disabled') && item.getAttribute('aria-hidden') !== 'true');
        }

        getFocusTrapElements() {
            return [this.toggler, ...this.getMenuFocusableElements()];
        }

        moveFocusWithArrow(key) {
            const focusableElements = this.getFocusTrapElements();

            if (!focusableElements.length) {
                return false;
            }

            const currentIndex = focusableElements.indexOf(document.activeElement);
            const isForward = key === 'ArrowDown' || key === 'ArrowRight';
            const isBackward = key === 'ArrowUp' || key === 'ArrowLeft';

            if (!isForward && !isBackward) {
                return false;
            }

            const nextIndex = currentIndex === -1
                ? (isForward ? 0 : focusableElements.length - 1)
                : (currentIndex + (isForward ? 1 : -1) + focusableElements.length) % focusableElements.length;

            focusableElements[nextIndex].focus();

            return true;
        }

        setMenuFocusability(isActive) {
            this.getMenuFocusableElements().forEach((item) => {
                if (isActive) {
                    if (item.dataset.menuMobileTabindex !== undefined) {
                        if (item.dataset.menuMobileTabindex === '') {
                            item.removeAttribute('tabindex');
                        } else {
                            item.setAttribute('tabindex', item.dataset.menuMobileTabindex);
                        }

                        delete item.dataset.menuMobileTabindex;
                    }

                    return;
                }

                if (item.dataset.menuMobileTabindex === undefined) {
                    item.dataset.menuMobileTabindex = item.getAttribute('tabindex') ?? '';
                }

                item.setAttribute('tabindex', '-1');
            });
        }

        handleKeydown(event) {
            if (!this.menuIsActive) {
                return;
            }

            if (
                !this.menu.contains(document.activeElement) &&
                document.activeElement !== this.toggler
            ) {
                return;
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                this.toggleMenu(false);
                this.toggler.focus();
                return;
            }

            if (this.moveFocusWithArrow(event.key)) {
                event.preventDefault();
                return;
            }

            if (event.key !== 'Tab') {
                return;
            }

            const trapElements = this.getFocusTrapElements();

            if (!trapElements.length) {
                return;
            }

            const firstElement = trapElements[0];
            const lastElement = trapElements[trapElements.length - 1];

            if (event.shiftKey && document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
                return;
            }

            if (!event.shiftKey && document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        }
    
        toggleMenu(forceState = !this.menuIsActive) {
            this.menuIsActive = forceState;
            this.menu.classList.toggle('is-active', this.menuIsActive);
            this.toggler.classList.toggle('is-open', this.menuIsActive);

            if (this.label) {
                const nextLabel = this.menuIsActive
                    ? this.label.dataset.labelOpen
                    : this.label.dataset.labelClosed;

                this.label.textContent = nextLabel || '';
                this.label.classList.toggle('is-open', this.menuIsActive);
            }

            this.toggler.setAttribute('aria-expanded', String(this.menuIsActive));
            this.menu.setAttribute('aria-hidden', String(!this.menuIsActive));
            this.setMenuFocusability(this.menuIsActive);
    
            this.toggleOverflow();
        }
    
        toggleOverflow() {
            // Calculate scrollbar width by comparing window inner width with document client width
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            
            if (this.menuIsActive) {
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            } else {
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0';
            }
        }
    }
    const baseUrl = `/wp-content/themes/izolmaster`;
    
    document.addEventListener('DOMContentLoaded', () => {
        const element = document.querySelector('.js-menu-mobile');
        if (element) {
            new MenuMobile(element);
            $('.menu-item-has-children > a').append(`<span class="dropdown-toggle"><img src="${baseUrl}/dist/img/menu-arrow.svg"></img></span>`);

        }
    });
    
    // menu mobile rozwijanie
    $(document).ready(function(){

        // Add hover event for desktop menu
        if (!window.matchMedia('(max-width: 1199px)').matches) {
            $('.menu-item-has-children').hover(
                function() {
                    // Mouse enter
                    $(this).find('ul.sub-menu').css('display', 'flex');
                }, 
                function() {
                    // Mouse leave
                    $(this).find('ul.sub-menu').css('display', '');
                }
            );
        }

        if (window.matchMedia('(max-width: 991px)').matches) {
            // Dodaj kliwalny element span do każdego linku z submenu
    
            $('.menu-item-has-children > a').each(function(){
                var wasOpened = false;
    
                // Obsługa kliknięcia na strzałkę
                $(this).find('.dropdown-toggle').on('click', function(e){
                    e.stopPropagation(); // Zapobiegaj propagacji, aby nie uruchomić zdarzenia kliknięcia na <a>
                    e.preventDefault();
                    $(this).parent().next('.sub-menu').slideToggle('slow');
                    $(this).parent().toggleClass('active');
                    wasOpened = !wasOpened;
                });
    
                // Obsługa kliknięcia na link
                $(this).on('click', function(e){
                    if (!wasOpened) {
                        e.preventDefault();
                        $(this).find('.dropdown-toggle').trigger('click'); // Symulacja kliknięcia na strzałkę
                    } else {
                        window.location.href = $(this).attr('href'); // Przejdź do linku
                    }
                });
    
                // Dodaj obsługę kliknięcia poza menu, aby resetować flagę
                $(document).on('click', function outsideClick(e){
                    if (!$(e.target).closest('.menu-item-has-children').length) {
                        wasOpened = false;
                        $('.sub-menu').slideUp('slow'); // Zamknij wszystkie sub-menu
                        $('.menu-item-has-children > a').removeClass('active');
                    }
                });
            });
        }
    });
})(jQuery);